import { Movimiento } from 'core/tarjeta/models/Movimiento';
import { Table } from 'shared/table';
import { formatCurrency, formatDate } from 'shared/utils';

export const CardMovementsTable = (props: { tableContent: Movimiento[] }) => {
  const montoTotal = () => {
    let total = 0;
    props.tableContent.forEach((item) => {
      total += item.importe;
    });
    return total;
  };

  return (
    <Table
      thead={
        <tr>
          <td>Fecha</td>
          <td>Nro. Autorización</td>
          <td>Establecimiento</td>
          <td>Rubro</td>
          <td>Importe</td>
          <td>Tipo de transacción</td>
        </tr>
      }
      tbody={
        <>
          {props.tableContent.map((item, index) => (
            <tr key={'movimiento' + index} data-testid={'movimiento-row-' + index}>
              <td>{formatDate(item.fecha)}</td>
              <td className="align-right">{item.numeroAutorizacion}</td>
              <td className="align-left">{item.establecimiento.nombreFantasia || ''}</td>
              <td>{item.establecimiento.rubro.nombre || ''}</td>
              <td className="align-right">{formatCurrency(item.importe)}</td>
              <td className="align-left">{item.tipoOperacion.detalle}</td>
            </tr>
          ))}
        </>
      }
      tfoot={
        <tr>
          <td colSpan={4}>Total</td>
          <td>{formatCurrency(montoTotal())}</td>
          <td></td>
        </tr>
      }
    />
  );
};
